export default __webpack_public_path__ + "static/moduli-min-cd5545b1bc57c087c7fa42dedb8dce63.png";